module.exports = __webpack_public_path__ + "static/media/CONSENTEMENT.645eec1a.rtf";